import { FC } from "react"
import React,{useEffect, useState, useMemo } from "react";
import { useIntl } from "react-intl"
import { KTSVG } from "../../../smallnation/helpers"
import { PageTitle } from "../../../smallnation/layout/core"
import services from "../../modules/services/services"
import { Pagination } from "../../modules/utility/Pagination";
import moment from "moment";
import $ from 'jquery';
import { CompanyVideoUpload } from "../companydirectory/companyVideoUpload";
//import { TablesWidget10, TablesWidget5,TablesWidget1, TablesWidget2,TablesWidget3,TablesWidget4,TablesWidget6,TablesWidget7,TablesWidget8,TablesWidget9,TablesWidget11,TablesWidget12,TablesWidget13  } from "../../../smallnation/partials/widgets"
//import { ProfileDirectoryInc } from "../../../smallnation/partials/widgets/tables/profileDirectoryInc"


const JobApplicationsList: FC = () => {
      const intl = useIntl()

      const ITEMS_PER_PAGE = 10; // Per page show the data pagination
      const [totalItems, setTotalItems] = useState(0);
      const [totalpages, settotalPages] = useState(0);
      const [currentPage, setCurrentPage] = useState(1);
      const [JobApplicationsList, setJobApplications] = useState([]);
      const Pagesize=10;
      useEffect(() =>
      {
        //getSchoolList();
        filterJobApplicationList(ITEMS_PER_PAGE,1);
        //getJobTypeList(ITEMS_PER_PAGE,'1');

      },[]);
      const filterJobApplicationList = (ITEMS_PER_PAGE,pageNumber) => {

        var searchTxt:any = $('#search_input').val();
        //var encoded_queryval = encodeURIComponent(searchTxt.trim());
        var encoded_queryval = searchTxt.trim();

console.log(searchTxt+' - '+encoded_queryval);

        var siteIdIn = "2";
        const requestObject={
            "siteId":"2",
            "searchText": encoded_queryval,
            "pageSize":ITEMS_PER_PAGE,
            "pageNumber":pageNumber
        }
       var accessTokenIn=sessionStorage.getItem("adminAccToken");
        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json',
                    'Authorization': "Bearer "+accessTokenIn
                    //'Authorization': accessTokenIn
                  },
          body: JSON.stringify(requestObject)
        };
        services.adminJobApplication(requestOptions).then((res) =>
        {
          console.log(JSON.stringify(res))
          if(res){
            //
            //$(".paginationContent").show();
            //alert(res[0].totalElement);
            setTotalItems(res.totalElements);
            settotalPages(Math.ceil(res.totalElements / ITEMS_PER_PAGE));
            setCurrentPage(pageNumber);
            setJobApplications(res.content);

            //
          }


        });
}

const searchList = () => {
  filterJobApplicationList(ITEMS_PER_PAGE,'1'); 
}
      const handlePageChange2 = (offset,triggerevent) => {
        // alert(offset);
        filterJobApplicationList(ITEMS_PER_PAGE,offset);
      };

      type Props = {
        className: string
      }
      return (
        <>
          <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'Job Applications List'})}</PageTitle>

          <h3 className="mb-7">Job Applications</h3>

        <div className={`card`}>

      {/* begin::Body */}
      <div className='card-body py-3'>
        {/* begin::Table container */}
        <div className='table-responsive'>
          {/* begin::Table */}
          <table className=''>
            <thead>
              <tr className='fw-bolder text-muted pb-3 '>
                <th  style={{minWidth:"450px"}}><input type="text" id="search_input" name="search_input" className="form-control" placeholder="" onChange={searchList}/> </th>
                <th className='min-w-140px'> <button type="button" onClick={searchList} className="btn btn-primary" style={{maxWidth: "135px"}}> Search </button></th>
              </tr>
            </thead>
            </table>
          <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3'>
            {/* begin::Table head */}
            <thead>
              <tr className='fw-bolder text-muted'>
                {/* <th className='w-25px'>
                  <div className='form-check form-check-sm form-check-custom form-check-solid'>
                    <input
                      className='form-check-input'
                      type='checkbox'
                      value='1'
                      data-kt-check='true'
                      data-kt-check-target='.widget-13-check'
                    />
                  </div>
                </th> */}
                <th className='min-w-200px'>Applied On</th>
                <th className='min-w-100px'>Job Title</th>
                <th className='min-w-140px'>Applicant Name</th>
                <th className='min-w-140px'>Company Name</th>

                <th className='min-w-100px text-end'>Actions</th>
              </tr>
            </thead>
            {/* end::Table head */}
            {/* begin::Table body */}
            <tbody>

            {
	          JobApplicationsList.map((data, index) => (
              <tr>
                {/* <td>
                  <div className='form-check form-check-sm form-check-custom form-check-solid'>
                    <input className='form-check-input widget-13-check' type='checkbox' value='1' />
                  </div>
                </td> */}
                 <td>
                  <a href={'/viewJobApplication?jobapplicationId='+data.applicationJobId} className='text-dark fw-bolder text-hover-primary d-block mb-1 fs-6'>
                  {(data.createdDate=='' || data.createdDate==null) ? '--' : moment(data.createdDate).utcOffset('-0400').format("MM/DD/YYYY, HH:mm:ss")}
                  </a>

                </td>
                <td>
                  <a href={'/viewJobApplication?jobapplicationId='+data.applicationJobId} className='text-dark fw-bolder text-hover-primary d-block mb-1 fs-6'>
                  {(data.jobTitle=='' || data.jobTitle==null) ? '--' : data.jobTitle}
                  </a>

                </td>
                <td>
                  <a href={'/viewJobApplication?jobapplicationId='+data.applicationJobId} className='text-dark fw-bolder text-hover-primary d-block mb-1 fs-6'>
                  {(data.firstName=='' || data.firstName==null) ? '--' : data.firstName+' '+data.lastName}

                  </a>

                </td>

                <td>
                  <a href={'/viewJobApplication?jobapplicationId='+data.applicationJobId} className='text-dark fw-bolder text-hover-primary d-block mb-1 fs-6'>
                  {(data.companyName=='' || data.companyName==null) ? '--' : data.companyName}
                  </a>

                </td>
                <td className='text-end'>
                  {/* <a
                    href='#'
                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                  >
                    <KTSVG path='/media/icons/duotune/general/gen019.svg' className='svg-icon-3' />
                  </a> */}
                  {/*  */}
                  <a
                    href={'/viewJobApplication?jobapplicationId='+data.applicationJobId}
                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                  >
                    <KTSVG path='/media/icons/duotune/art/art012.svg' className='svg-icon-3' />
                    {/* <KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-3' /> */}
                  </a>
                  {/* <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                    <KTSVG path='/media/icons/duotune/general/gen027.svg' className='svg-icon-3' />
                  </a> */}
                </td>
              </tr>
              ))}

            </tbody>
            {/* end::Table body */}
          </table>



          {/* end::Table */}
        </div>



<Pagination

                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={handlePageChange2}

                />

        {/* end::Table container */}
      </div>
      {/* begin::Body */}
    </div>



        </>
      )
    }
export {JobApplicationsList}